module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('tbody', _vm._l((_vm.displayTiers), function(tier) {
    return _c('tr', {
      key: tier.id
    }, [_c('td', [_c('div', {
      staticClass: "md-radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.radioValue),
        expression: "radioValue"
      }],
      staticClass: "md-radiobtn",
      attrs: {
        "type": "radio",
        "id": (_vm.idPrefix + "-" + (tier.id)),
        "name": tier.name
      },
      domProps: {
        "value": tier.id,
        "checked": _vm._q(_vm.radioValue, tier.id)
      },
      on: {
        "change": [function($event) {
          _vm.radioValue = tier.id
        }, _vm.tiersSelected]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": (_vm.idPrefix + "-" + (tier.id))
      }
    }, [_c('span'), _vm._v(" "), _c('span', {
      staticClass: "check"
    }), _vm._v(" "), _c('span', {
      staticClass: "box"
    }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(tier.name) + "\n\t\t\t\t\t")])])])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_c('span', {
    staticClass: "padding-left-35"
  }, [_vm._v("\n\t\t\t\tTier name\n\t\t\t")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-adcebc1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/MenuManager/MenuTiers/MenuTiersPicker.vue
// module id = 775
// module chunks = 0